// extracted by mini-css-extract-plugin
export default {"container":"DefineMainLanguage_container__TLgOb"};